import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';

/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
    document.addEventListener('DOMContentLoaded', () => {
        // Registering Service Worker
        navigator.serviceWorker
            // eslint-disable-next-line no-undef
            .register(`${ThemeURLS.childThemeURL}/sw.php`, {
                scope: '/',
            })
            .then((reg) => console.log(reg.scope))
            .catch((error) => console.log(error.message));
    });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
    const mobileMediaQuery = window.matchMedia('(max-width: 991px)');
    return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
    matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
    const modalInstances = [];
    CwLoadModules.modals().then((CwModals) => {
        modals.forEach((modalBtn, index) => {
            modalInstances[index] = new CwModals('.cw-modal');
            modalInstances[index].init();
        });
    });
}

/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
    'results-slider': 'results-carousel',
    'results-slider__sidebar': 'results-slider-sidebar',
    'awards-wrap': 'awards-carousel',
    'awards-wrap-sidebar': 'awards-carousel-sidebar',
    'testimonials-section-slider': 'testimonials-carousel',
    'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
    'grid-attorney': 'team-carousel',
    'grid-videos': 'videos-carousel',
    'attorney-sidebar-slider': 'team-sidebar-widget',
    'in-the-news-slider': 'in-the-news-carousel',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
    const name = document.getElementById(key);
    if (name) {
        CwLoadModules.swiperSliders(value).then((module) => {
            module.default();
        });
    }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
    'click',
    (event) => {
        if (!event.target.closest('.scroll')) return;

        const hashValue = event.target.closest('.scroll').getAttribute('href');
        const target = document.querySelector(hashValue);

        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        history.pushState(null, null, hashValue);
        event.preventDefault();
    },
    false
);

/**
 * Load More
 */
const loadMore = null || document.querySelector('.load-more');
const categoryFilter = null || document.querySelector('.cw-filter');

if (loadMore || categoryFilter) {
    const enablePagination = loadMore.dataset.pagination;

    CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
        const ajaxCalls = new cwAjaxLib({
            enablePagination: enablePagination,
        });
        ajaxCalls.init();
        if (categoryFilter) ajaxCalls.filter(categoryFilter);
    });
}

/**
 * Practice area landing — PA grid cards: reveal body text on click / keyboard.
 */
const paLandGridCards = document.querySelectorAll('.pa-land__grid-card--expandable');
if (paLandGridCards.length) {
    paLandGridCards.forEach((card) => {
        const toggle = () => {
            const open = card.classList.toggle('is-open');
            card.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        card.addEventListener('click', toggle);

        card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
            }
        });
    });
}

/**
 * Legally Reviewed box: toggle summary/details content.
 */
const legallyReviewedCards = document.querySelectorAll('.legally-reviewed-box__lawyer--expandable');
if (legallyReviewedCards.length) {
    legallyReviewedCards.forEach((card) => {
        const reviewedBox = card.closest('.legally-reviewed-box');
        const toggle = () => {
            if (!reviewedBox) return;
            const open = reviewedBox.classList.toggle('is-open');
            card.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            toggle();
        });

        card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
            }
        });
    });
}

/**
 * Media page: year filter and search (client-side, no reload).
 * Loads media-carousel after DOM so Swiper exists before we filter.
 * Uses width-collapsed slides instead of display:none so Swiper layout stays valid.
 */
document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('media-appearances-filter-form');
    const yearSelect = document.getElementById('media_year');
    const yearToggle = document.getElementById('media_year_toggle');
    const yearPanel = document.getElementById('media_year_listbox');
    const yearToggleText = document.getElementById('media_year_toggle_text');
    const yearCustom = document.querySelector('.media-year-custom');
    const searchInput = document.getElementById('media_search');
    const yearBlocks = document.querySelectorAll('.media-appearances-year-block');
    const noResults = document.querySelector('.media-appearances-no-results');

    if (!form || !yearSelect || !searchInput || !yearBlocks.length) {
        return;
    }

    import(/* webpackChunkName: "media-carousel" */ './modules/media-carousel.js').then(function (mc) {
        let searchDebounce;

        const slideMatchesNeedle = function (item, needle) {
            if (!needle) return true;
            const fromAttr = (item.getAttribute('data-media-search') || '').toLowerCase();
            const fromDom = (item.textContent || '')
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();
            const haystack = `${fromAttr} ${fromDom}`;
            return haystack.indexOf(needle) !== -1;
        };

        const updateMediaState = function () {
            const selectedYear = yearSelect.value;
            const searchTerm = searchInput.value.trim().toLowerCase();
            let selectedYearBlock = null;

            yearBlocks.forEach(function (yearBlock) {
                const isSelectedYear = yearBlock.getAttribute('data-media-year') === selectedYear;
                const mediaItems = yearBlock.querySelectorAll('.media-appearance-item');

                yearBlock.hidden = !isSelectedYear;
                yearBlock.style.display = isSelectedYear ? '' : 'none';

                yearBlock.querySelectorAll('.media-appearances-swiper').forEach(function (swiperEl) {
                    swiperEl.hidden = false;
                    swiperEl.style.display = '';
                    swiperEl.classList.remove('is-media-searching');
                });

                if (!isSelectedYear) {
                    mediaItems.forEach(function (item) {
                        item.classList.remove('is-media-search-match', 'media-appearance-item--excluded');
                    });
                    const hiddenSw = yearBlock.querySelector('.media-appearances-swiper');
                    if (hiddenSw && hiddenSw.swiper) {
                        try {
                            hiddenSw.swiper.destroy(true, true);
                        } catch (e) {
                            // ignore
                        }
                    }
                    return;
                }

                selectedYearBlock = yearBlock;
            });

            if (!selectedYearBlock) {
                if (noResults) {
                    noResults.removeAttribute('hidden');
                    noResults.style.display = '';
                }
                return;
            }

            let selectedYearHasResults = false;
            const selectedYearSwiper = selectedYearBlock.querySelector('.media-appearances-swiper');
            const prevActiveIndex =
                selectedYearSwiper && selectedYearSwiper.swiper ? selectedYearSwiper.swiper.activeIndex : 0;

            selectedYearBlock.querySelectorAll('.media-appearance-item').forEach(function (item) {
                const isMatch = slideMatchesNeedle(item, searchTerm);

                item.classList.toggle('is-media-search-match', Boolean(searchTerm) && isMatch);
                item.classList.toggle('media-appearance-item--excluded', Boolean(searchTerm) && !isMatch);

                if (isMatch) {
                    selectedYearHasResults = true;
                }
            });

            if (selectedYearSwiper) {
                selectedYearSwiper.classList.toggle('is-media-searching', Boolean(searchTerm) && selectedYearHasResults);
                selectedYearSwiper.hidden = !selectedYearHasResults;
                selectedYearSwiper.style.display = selectedYearHasResults ? '' : 'none';
            }

            if (noResults) {
                if (selectedYearHasResults) {
                    noResults.setAttribute('hidden', '');
                    noResults.style.display = 'none';
                } else {
                    noResults.removeAttribute('hidden');
                    noResults.style.display = '';
                }
            }

            if (selectedYearSwiper && selectedYearHasResults) {
                mc.createMediaSwiper(selectedYearSwiper);
                const swiper = selectedYearSwiper.swiper;
                if (swiper) {
                    const slides = selectedYearSwiper.querySelectorAll('.swiper-slide.media-appearance-item');
                    const indexOfFirstNonExcluded = function () {
                        let first = -1;
                        slides.forEach(function (slide, index) {
                            if (first === -1 && !slide.classList.contains('media-appearance-item--excluded')) {
                                first = index;
                            }
                        });
                        return first;
                    };
                    const indexNearestMatchFrom = function (fromIdx) {
                        let upward = -1;
                        slides.forEach(function (slide, index) {
                            if (
                                index >= fromIdx &&
                                upward === -1 &&
                                !slide.classList.contains('media-appearance-item--excluded')
                            ) {
                                upward = index;
                            }
                        });
                        if (upward > -1) return upward;
                        return indexOfFirstNonExcluded();
                    };

                    let targetIndex = searchTerm ? indexNearestMatchFrom(prevActiveIndex) : 0;
                    if (targetIndex < 0) {
                        targetIndex = 0;
                    }
                    requestAnimationFrame(function () {
                        swiper.slideTo(targetIndex, 0, false);
                        requestAnimationFrame(function () {
                            swiper.update();
                        });
                    });
                }
            } else if (selectedYearSwiper && !selectedYearHasResults) {
                if (selectedYearSwiper.swiper) {
                    try {
                        selectedYearSwiper.swiper.destroy(true, true);
                    } catch (e) {
                        // ignore
                    }
                }
            }
        };

        const runUpdate = function () {
            updateMediaState();
        };

        const syncYearCustomUI = function (value) {
            if (yearToggleText) {
                yearToggleText.textContent = value;
            }
            if (!yearPanel) return;
            yearPanel.querySelectorAll('.media-year-custom__option').forEach(function (btn) {
                var sel = btn.value === value;
                btn.setAttribute('aria-selected', sel ? 'true' : 'false');
                btn.classList.toggle('is-active', sel);
            });
        };

        const closeYearPanel = function () {
            if (!yearPanel || !yearToggle) return;
            yearPanel.hidden = true;
            yearToggle.setAttribute('aria-expanded', 'false');
        };

        const openYearPanel = function () {
            if (!yearPanel || !yearToggle) return;
            yearPanel.hidden = false;
            yearToggle.setAttribute('aria-expanded', 'true');
        };

        if (yearCustom && yearToggle && yearPanel) {
            syncYearCustomUI(yearSelect.value);
            yearToggle.addEventListener('click', function (e) {
                e.stopPropagation();
                if (yearPanel.hidden) {
                    openYearPanel();
                } else {
                    closeYearPanel();
                }
            });
            yearPanel.addEventListener('click', function (e) {
                var opt = e.target.closest('.media-year-custom__option');
                if (!opt) return;
                var val = opt.value;
                yearSelect.value = val;
                syncYearCustomUI(val);
                closeYearPanel();
                runUpdate();
            });
            document.addEventListener('click', function (e) {
                if (!yearPanel.hidden && !yearCustom.contains(e.target)) {
                    closeYearPanel();
                }
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && !yearPanel.hidden) {
                    closeYearPanel();
                    yearToggle.focus();
                }
            });
        }

        runUpdate();

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            runUpdate();
        });

        yearSelect.addEventListener('change', function () {
            syncYearCustomUI(yearSelect.value);
            runUpdate();
        });

        searchInput.addEventListener('input', function () {
            clearTimeout(searchDebounce);
            searchDebounce = setTimeout(runUpdate, 120);
        });
    });
});

// Handle sidebar child pages collapse/expand
document.addEventListener('DOMContentLoaded', function () {
    // Find all sidebar child pages widgets
    document.querySelectorAll('.widget_cw_child_pages_widget .sidebar-title').forEach(function(sidebarTitle) {
        // Set initial state: open (no .collapsed)
        const holder = sidebarTitle.closest('.sidebar-holder');
        const list = holder ? holder.querySelector('.list') : null;
        sidebarTitle.classList.remove('collapsed');
        if (list) {
            list.style.display = '';
        }
        
        sidebarTitle.style.cursor = "pointer";
        
        sidebarTitle.addEventListener('click', function() {
            if (!list) return;
            const isCollapsed = sidebarTitle.classList.toggle('collapsed');
            if (isCollapsed) {
                list.style.display = 'none';
            } else {
                list.style.display = '';
            }
        });
    });
});


